import { useReadPresetApi } from '@aibees/shared/api';
import { TransferListConfig } from '@aibees/shared/features';
import { useTableLayoutTemplateContext } from '@aibees/shared/features/advance-table/components/table-layout-modifier-dialog/context';
import { useMemo } from 'react';
import { TableLayoutTemplate } from '../types';

export function useSingleTemplate(id: string, config: TransferListConfig) {
  const api = useReadPresetApi<TableLayoutTemplate>(id);
  const { selectedTemplate } = useTableLayoutTemplateContext();

  const isCurrent = selectedTemplate?.id === id;

  const items = useMemo(() => {
    return config.items?.filter(
      (x) => !api.data?.value?.excluded?.includes(x.id)
    );
  }, [config.items, api.data]);
  return { items, api, isCurrent };
}
